export default __webpack_public_path__ + "static/media/1953.29401149.png";